import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import FrontCard from './FreelanceFrontCard.jsx';
import BackCard from './FreelanceBackCard.jsx';
import SearchCard from '../SearchCard.jsx';

export default class FreelanceSearchCard extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.object,
    freelance: PropTypes.shape({
      user: PropTypes.shape({
        id: PropTypes.number.isRequired,
        image: PropTypes.object,
        firstname: PropTypes.string
      }).isRequired,
      tjm_min: PropTypes.number,
      tjm_max: PropTypes.number,
      job: PropTypes.string,
      availability: PropTypes.string,
    }).isRequired,
    isAdmin: PropTypes.bool.isRequired,
    link: PropTypes.string.isRequired,
    score: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),//false => no data
  };

  static defaultProps = {
    isAdmin: false,
  }

  render() {
    const {currentUser, freelance, ...props} = this.props;

    return <SearchCard className="freelance-search-card" link={props.link}>
      <FrontCard {...freelance} currentUser={currentUser} isAdmin={props.isAdmin} score={props.score}/>
      <BackCard {...freelance} currentUser={currentUser}/>
    </SearchCard>;
  }
}
